"use client";

import { useCallback } from "react";

import { useSession as useBetterAuthSession } from "@/lib/auth-client";

type RefetchFn = () => void;

export function useSession() {
  const { data: session, isPending, refetch } = useBetterAuthSession();

  // Wrap refetch with useCallback for stable reference and proper typing
  const safeRefetch: RefetchFn = useCallback(() => {
    refetch().catch(() => {
      // Silently handle refetch errors - session will sync on next render
    });
  }, [refetch]);

  return {
    user: session?.user || null,
    session,
    isLoading: isPending,
    refetch: safeRefetch,
  };
}
